const KEY = 'smartcases_cart';

export const getCart = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const saveCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event('smartcases-cart'));
};

export const itemKey = (i) => `${i.slug}|${i.variant || ''}|${i.payment || ''}`;

export const addToCart = (item) => {
  const items = getCart();
  const existing = items.find((x) => itemKey(x) === itemKey(item));
  if (existing) {
    existing.qty += item.qty || 1;
  } else {
    items.push({ ...item, qty: item.qty || 1 });
  }
  saveCart(items);
};

export const updateQty = (key, qty) => {
  let items = getCart();
  items = qty <= 0 ? items.filter((x) => itemKey(x) !== key) : items.map((x) => (itemKey(x) === key ? { ...x, qty } : x));
  saveCart(items);
};

export const clearCart = () => saveCart([]);

export const cartTotal = (items) => items.reduce((s, i) => s + i.price * i.qty, 0);

export const formatEur = (n) => `${n.toLocaleString('de-DE')} €`;
